import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import Label from "../../components/label";
import MakeAPICall from "../../apiCalls/common";
import {
  getCalendarDatesByMonthStartingThisWeek,
  getCurrentMonthAndYear,
  getFormattedDate,
  getMomentObjFormmaterWithTimeZone,
  mergeDateAndTimeUsingMomentObj
} from "../../utils/dateTimeHelper";
import CalendarUI from "../../containers/Shift/CalenderUI";
import { addDoctorShiftAPI, deleteDoctorShiftAPI, editDoctorShiftAPI, getDoctorShiftsAPI } from "../../apiRoutes";
import Loader from "../../components/loader";
import _ from "lodash";
import moment from "moment";
import DropdownMultiCheckbox from "../../components/form/dropDownWithCheckbox";
import { FilterAndProps } from "../../containers/Shift/AddShiftForm";
import CustomModal from "../../components/modal";

function ShiftsPage(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [apiCall, setApiCall] = useState(false);
  const [apiCall2, setApiCall2] = useState(false);
  const [leafAPICall, setLeafAPICall] = useState(false);
  const [switchAPICall, setSwitchAPICall] = useState(false);
  const [hushAPICall, setHushAPICall] = useState(false);
  const [scheduleFilter, setScheduleFilter] = useState(FilterAndProps);
  const [calendarDates, setCalendarDates] = useState(getCalendarDatesByMonthStartingThisWeek());
  const [currentMonth, setCurrentMonth] = useState(getCurrentMonthAndYear());

  const [apiCounterForForm, setAPICounterForForm] = useState(0); // i'm using this to close the model once api is success. If there is an error then I don't want to close the form so user can edit the same form

  const doctorList = useMemo(() => {
    return props.doctorList.filter(doctor => {
      // Run all doctors through the all the selected filters
      for (const valuesForScheduleFilterElement of scheduleFilter) {
        if (valuesForScheduleFilterElement.filter(doctor) && doctorInSchedule(doctor, scheduleFilter)) {
          return true;
        }
      }
    });
  }, [props.doctorList, scheduleFilter]);

  const [filters, setFilters] = useState();
  const [shiftsByDate, setShiftsByDate] = useState([]);

  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    errorText: <></>,
    errorTitle: ""
  })

  function doctorInSchedule(doctor, scheduleFilter) {
    for (let scheduleFilterElement of scheduleFilter) {
      if (scheduleFilterElement.title === "Instant Leaf" && doctor.isAccessToInstantSwitchMC) {
        return true;
      }

      if (scheduleFilterElement.title === "Instant Switch" && doctor.isAccessToInstantSwitch) {
        return true;
      }

      if (scheduleFilterElement.title === "Instant Hush" && doctor.isAccessToInstantHush) {
        return true;
      }
    }
    return false;
  }

  function handleShiftFormSubmit(values, isEdit) {
    if (values.shiftDates.length === 0) {
      return;
    }

    const { scheduleFilter, ...data } = values;
    setIsLoading(true);
    
    // Ensure shiftDate and times are Moment objects
    const shiftDate = moment(data.shiftDates[0]);
    const shiftStartTime = moment(data.shiftStartTime);
    const shiftEndTime = moment(data.shiftEndTime);

    // let shiftDates;
    // if (values.shiftDates && Array.isArray(values.shiftDates) && !isEdit) {
    //   shiftDates = values.shiftDates.map((date) => moment(date).add(1, 'd').toISOString());
    // } else if (!isEdit && values.shiftDates) {
    //   shiftDates = moment(values.shiftDates).add(1, 'd').toISOString();
    // }

    const dataObj = {
      ...data,
      shiftStartTime: mergeDateAndTimeUsingMomentObj(shiftDate, moment(data.shiftStartTime)),
      shiftEndTime: mergeDateAndTimeUsingMomentObj(shiftDate, moment(data.shiftEndTime)),
      shiftDates: isEdit
        ? data.shiftDates  // If isEdit is true, keep original shiftDates
        : values.shiftDates.map(shiftDate => {
            const result = mergeDateAndTimeUsingMomentObj(moment(shiftDate), moment(data.shiftStartTime));
            return result;
          })
    };    
    
    if (isEdit) {
      dataObj.shiftDate = mergeDateAndTimeUsingMomentObj(moment(data.shiftDates), moment(data.shiftStartTime));;
      delete dataObj.shiftDates;
    }

    if (scheduleFilter.title === "Instant Leaf") {
      callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_LEAF");
    } else if (scheduleFilter.title === "Instant Switch") {
      callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_SWITCH");
    } else if (scheduleFilter.title === "Instant Hush") {
      callAPI(dataObj, isEdit ? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_HUSH");
    }
    // scheduleFilter.forEach((scheduleFilterElement, index) => {
    //     if (scheduleFilterElement.title === "Instant Leaf") {
    //       callAPI(dataObj, isEdit? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_LEAF");
    //     } else if (scheduleFilterElement.title === "Instant Switch") {
    //       callAPI(dataObj, isEdit? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_SWITCH");
    //     } else if (scheduleFilterElement.title === "Instant Hush") {
    //       callAPI(dataObj, isEdit? editDoctorShiftAPI : addDoctorShiftAPI, "INSTANT_HUSH");
    //     }
    // });
}

  function callAPI(dataToSend, API, type) {
    if (type === "INSTANT_LEAF") {
      setLeafAPICall({
        reqType: "POST",
        reqUrl: API,
        dataObj: { shiftFor: "INSTANT_LEAF", ...dataToSend },
        params: {},
        headers: {},
        successCallback: res => {
          setIsLoading(false);
          setAPICounterForForm((prev) => prev + 1);
          getDoctorShifts();
        },
        failureCallback: err => {
          console.log("Error here: ", err);
          setIsLoading(false);
          setErrorModal({
            isOpen: true,
            errorText: <>
              <p>{err.message ? err.message : "Something went wrong"}</p>
              {
                err.data && err.data.length ? (
                  err.data.map((shift, index) => {
                    return (
                      <div className="mb-3" key={index}>
                        <p className="mb-0">Shift Date: {moment(shift.shiftDate).format("DD/MM/YYYY")}</p>
                        <p className="mb-0">Time: {moment(shift.shiftStartTime).format("h:mm a")} - {moment(shift.shiftEndTime).format("h:mm a")}</p>
                      </div>
                    )
                  })
                ) : ('')
              }
            </>,
            errorTitle: ""
          })
        },
        showErrPopup: false
      });
    } else if (type === "INSTANT_SWITCH") {
      setSwitchAPICall({
        reqType: "POST",
        reqUrl: API,
        dataObj: { shiftFor: "INSTANT_SWITCH", ...dataToSend },
        params: {},
        headers: {},
        successCallback: res => {
          setIsLoading(false);
          setAPICounterForForm((prev) => prev + 1);
          getDoctorShifts();
        },
        failureCallback: err => {
          console.log("Error here: ", err);
          setIsLoading(false);
          setErrorModal({
            isOpen: true,
            errorText: <>
              <p>{err.message ? err.message : "Something went wrong"}</p>
              {
                err.data && err.data.length ? (
                  err.data.map((shift, index) => {
                    return (
                      <div className="mb-3" key={index}>
                        <p className="mb-0">Shift Date: {moment(shift.shiftDate).format("DD/MM/YYYY")}</p>
                        <p className="mb-0">Time: {moment(shift.shiftStartTime).format("h:mm a")} - {moment(shift.shiftEndTime).format("h:mm a")}</p>
                      </div>
                    )
                  })
                ) : ('')
              }
            </>,
            errorTitle: ""
          })
        },
        showErrPopup: false
      });
    } else if (type === "INSTANT_HUSH") {
      setHushAPICall({
        reqType: "POST",
        reqUrl: API,
        dataObj: { shiftFor: "INSTANT_HUSH", ...dataToSend },
        params: {},
        headers: {},
        successCallback: res => {
          setIsLoading(false);
          setAPICounterForForm((prev) => prev + 1);
          getDoctorShifts();
        },
        failureCallback: err => {
          console.log("Error here: ", err);
          setIsLoading(false);
          setErrorModal({
            isOpen: true,
            errorText: <>
              <p>{err.message ? err.message : "Something went wrong"}</p>
              {
                err.data && err.data.length ? (
                  err.data.map((shift, index) => {
                    return (
                      <div className="mb-3" key={index}>
                        <p className="mb-0">Shift Date: {moment(shift.shiftDate).format("DD/MM/YYYY")}</p>
                        <p className="mb-0">Time: {moment(shift.shiftStartTime).format("h:mm a")} - {moment(shift.shiftEndTime).format("h:mm a")}</p>
                      </div>
                    )
                  })
                ) : ('')
              }
            </>,
            errorTitle: ""
          })
        },
        showErrPopup: false
      });
    }
  }

  function getDoctorShifts(calendarDatesParam, filters) {
    const startDate = calendarDatesParam ? calendarDatesParam[0][0].date : calendarDates[0][0].date;
    const totalArrayLength = calendarDatesParam ? calendarDatesParam.length : calendarDates.length;
    const endDate = calendarDatesParam ? calendarDatesParam[totalArrayLength - 1][6]["date"] : calendarDates[totalArrayLength - 1][6]["date"];

    const dataToSend = {
      ...(filters || {}),
      shiftFor: getDataToSend(),
      startDate: getMomentObjFormmaterWithTimeZone(startDate, "DD/MM/YYYY").startOf("day").toISOString(),
      endDate: getMomentObjFormmaterWithTimeZone(endDate, "DD/MM/YYYY").endOf("day").toISOString()
    };

    if (filters) {
      dataToSend["filters"] = filters;
    }

    setIsLoading(true);
    setApiCall2({
      reqType: "POST",
      reqUrl: getDoctorShiftsAPI,
      dataObj: dataToSend,
      params: {},
      headers: {},
      successCallback: res => {
        const shifts = res.data?.data;
        for (const shift of shifts) {
          shift.shiftDate = getFormattedDate(shift.shiftDate, "DD/MM/YYYY");
          const doctor = _.find(doctorList, { _id: shift.doctorId });
          if (doctor) {
            shift.doctorId = {
              _id: doctor._id, firstName: doctor.firstName, lastName: doctor.lastName, profilePic: doctor.profilePic
            };
          }
        }
        const shiftsGroup = _.groupBy(shifts, "shiftDate");
        setShiftsByDate(shiftsGroup);
        setIsLoading(false);
      },
      failureCallback: err => {
        setIsLoading(false);
      }
    });
  }

  function deleteShift(shiftId) {
    setIsLoading(true);
    setApiCall({
      reqType: "POST",
      reqUrl: deleteDoctorShiftAPI,
      dataObj: {
        shiftId: shiftId
      },
      params: {},
      headers: {},
      successCallback: res => {
        setIsLoading(false);
        getDoctorShifts();
      },
      failureCallback: err => {
        if (err.message === "This doctor has a booking during this shift") {
          setErrorModal({
            isOpen: true,
            errorText: (
              <div style={{ textAlign: "center" }}>
                <p className="bold-font black-light-font-color"><strong>Cannot Delete Shift</strong></p>
                <p>This doctor has a booking during this shift</p>
                <p>Once bookings during this shift are re-scheduled, you will be able to delete this shift</p>
              </div>
            ),
            errorTitle: (
              <div style={{ textAlign: "center" }}>
                Instant Consult
              </div>
            )
          });
        }
        setIsLoading(false);
      },
      showErrPopup: false
    });
  }

  function getNextMonthCalender(filters) {
    const nextMonth = moment(calendarDates[0][0].date, "DD/MM/YYYY").add(4, "weeks");
    const newCalendarDates = getCalendarDatesByMonthStartingThisWeek(nextMonth);
    setCalendarDates(newCalendarDates);
    getDoctorShifts(newCalendarDates, filters);
  }

  function getPreviousMonthCalender(filters) {
    const previousMonth = moment(calendarDates[0][0].date, "DD/MM/YYYY").subtract(4, "weeks");
    const newCalendarDates = getCalendarDatesByMonthStartingThisWeek(previousMonth);
    setCalendarDates(newCalendarDates);
    getDoctorShifts(newCalendarDates, filters);
  }

  const closeErrorModal = () => {
    setErrorModal({
      isOpen: false,
      errorText: <></>,
      errorTitle: ""
    })
  }
  // Old version
  // function getNextMonthCalender(filters) {
  //   let nextMonthNumber = getNextMonthFrom(currentMonth);
  //   let newCalendarDates = getCalendarDatesByMonth(nextMonthNumber.month, nextMonthNumber.year);
  //   setCurrentMonth(nextMonthNumber);
  //   setCalendarDates(newCalendarDates);
  //   getDoctorShifts(newCalendarDates, filters);
  // }
  //
  // function getPreviousMonthCalender(filters) {
  //   let previousMonthNumber = getPreviousMonthFrom(currentMonth);
  //   let newCalendarDates = getCalendarDatesByMonth(previousMonthNumber.month, previousMonthNumber.year);
  //   setCurrentMonth(previousMonthNumber);
  //   setCalendarDates(newCalendarDates);
  //   getDoctorShifts(newCalendarDates, filters);
  // }

  useEffect(() => getDoctorShifts(calendarDates, filters), [scheduleFilter, filters]);

  useEffect(() => getDoctorShifts(), []);

  function getDataToSend() {
    const scheduleDataToSend = [];
    for (const item of scheduleFilter) {
      if (item.title === "Instant Leaf") {
        scheduleDataToSend.push("INSTANT_LEAF");
      } else if (item.title === "Instant Switch") {
        scheduleDataToSend.push("INSTANT_SWITCH");
      } else if (item.title === "Instant Hush") {
        scheduleDataToSend.push("INSTANT_HUSH");
      }
    }
    return scheduleDataToSend;
  }

  return (<div className="row doctor-shifts-page p-2 pb-4 mb-5">
    <div className="row w-100 p-0 m-0 border-bottom pb-2">
      <div className="col-sm-12 pt-3 pl-3 pb-2">
        <Label title="Instant Extras Shifts" className="big" />
      </div>
    </div>

    <div className="col-sm-12 pl-0 pt-4">
      <Label title={"Schedule "} className={"w-100 mx-4 mb-0"} />
      <DropdownMultiCheckbox
        isMultiple={true}
        defaultValue={scheduleFilter}
        className="min-w-200 mx-4"
        placeholder=""
        onChange={setScheduleFilter}
        value={scheduleFilter}
        optionList={FilterAndProps}
      />
    </div>
    <div className="col-sm-12 calendarUI-container">
      <CalendarUI calendarDates={calendarDates} shiftsByDate={shiftsByDate} doctorList={doctorList}
        handleShiftFormSubmit={(formData, isEdit) => handleShiftFormSubmit(formData, isEdit)}
        getPreviousMonthCalender={(filter) => getPreviousMonthCalender(filter)}
        getNextMonthCalender={(filter) => getNextMonthCalender(filter)}
        deleteShift={(id) => deleteShift(id)} clearFilter={() => setScheduleFilter([])}
        handleFilterChange={setFilters} scheduleFilter={scheduleFilter}
        handleFormSubmitCounter={apiCounterForForm}
      />
    </div>
    <CustomModal
      openModal={errorModal.isOpen}
      title={errorModal.errorTitle}
      useOneButton={true}
      cancelEvent={() => closeErrorModal()}
      modalBodyContent={
        errorModal.errorText
      }
      cancelText={"Okay"}
    />
    <MakeAPICall apiParam={apiCall} />
    <MakeAPICall apiParam={apiCall2} />
    <MakeAPICall apiParam={leafAPICall} />
    <MakeAPICall apiParam={switchAPICall} />
    <MakeAPICall apiParam={hushAPICall} />
    <Loader loading={isLoading} />
  </div>);
}

const mapStateToProps = props => ({
  commonReducers: props.commonReducers, doctorList: props.serverConstants.doctorAndNurseList
});

export default connect(mapStateToProps, null)(ShiftsPage);
